module.exports = __webpack_public_path__ + "static/Clothes4All-Beach-NO_original-3c4c1289fa7fbdae92228c21753dca4a.mp4";